import React, { useState } from 'react';
import dynamic from 'next/dynamic';
import HeaderLogo from 'components/commercetools-ui/organisms/header/header-logo';
import HeaderNavigationMobile from 'components/commercetools-ui/organisms/header/header-navigation/header-navigation-mobile';
import { HeaderProps } from 'components/commercetools-ui/organisms/header/types';
import UtilitySection from 'components/commercetools-ui/organisms/header/utility-section';
import HeaderNavigationTopLevel, { LevelOneCategory } from './header-navigation-top-level';
import SearchInputAlgolia from '../product/product-list-algolia/components/search-header/algoliaSearch';
// build triger
// const AlgoliaSearch = dynamic(() => import('components/commercetools-ui/atoms/search-algolia'));
// const CommercetoolsSearch = dynamic(() => import('components/commercetools-ui/atoms/search'));
const DefaultSearch = dynamic(() => import('components/commercetools-ui/atoms/search-default'));

export interface menu {
  dataSourceId?: string;
  dataSource?: LevelOneCategory[];
}
const Header: React.FC<HeaderProps> = ({
  navLinks,
  logo,
  logoMobile,
  logoLink,
  logoLinkMobile,
  emptyCartTitle,
  emptyCartSubtitle,
  emptyCartImage,
  emptyCartCategories,
  emptyWishlistTitle,
  emptyWishlistSubtitle,
  emptyWishlistImage,
  emptyWishlistCategories,
  contentFulHeader,
  menu,
  searchConfiguration,
}) => {
  // temporarily using default search component
  // const Search = enableAlgoliaSearch ? AlgoliaSearch : CommercetoolsSearch;
  const Search = DefaultSearch;
  const [isAlgoliaSearch, setIsAlgoliaSearch] = useState(false);
  const isSearchPage = false;
  return (
    <div>
      {!contentFulHeader ? (
        <header className="relative h-fit w-full border-neutral-400 bg-white">
          <div
            aria-label="Top"
            className="mx-auto flex w-full items-center justify-between px-16 pb-12 md:px-24 lg:px-20 xl:px-48"
          >
            <HeaderNavigationMobile
              logo={logoMobile}
              links={navLinks}
              logoLink={logoLinkMobile}
              data={undefined}
              contentFulHeader={contentFulHeader}
            />

            <div className="ml-0 flex h-full w-full justify-start lg:relative lg:ml-20 xl:ml-0 xl:w-fit">
              <HeaderLogo
                logo={logo}
                logoLink={logoLink}
                imageClassName="flex h-44 w-188 md:w-250 justify-center text-center text-16 font-bold md:h-76 md:text-28"
              />
            </div>

            <div className="flex">
              <div className="relative mr-[16px] hidden w-[340px] px-16 py-12  xl:block">
                <Search />
              </div>

              <UtilitySection
                emptyCartTitle={emptyCartTitle}
                emptyCartSubtitle={emptyCartSubtitle}
                emptyCartImage={emptyCartImage}
                emptyCartCategories={emptyCartCategories}
                emptyWishlistTitle={emptyWishlistTitle}
                emptyWishlistSubtitle={emptyWishlistSubtitle}
                emptyWishlistImage={emptyWishlistImage}
                emptyWishlistCategories={emptyWishlistCategories}
              />
            </div>
          </div>

          <div className="relative block w-full border-t border-neutral-400 px-16 py-8 md:px-24 lg:px-20 xl:hidden xl:px-48">
            <Search />
          </div>

          {/* <HeaderNavigationDesktop links={navLinks} tiles={tiles ?? []} /> */}
          <HeaderNavigationTopLevel data={undefined} />
        </header>
      ) : (
        <header className="relative h-fit w-full border-neutral-400 bg-white">
          <div
            aria-label="Top"
            className="mx-auto flex h-[56] max-w-7xl items-center justify-between p-10 md:px-24 md:pb-20 md:pt-0 lg:px-20 xl:px-28"
          >
            <HeaderNavigationMobile
              logo={logoMobile}
              links={navLinks}
              logoLink={logoLinkMobile}
              data={menu}
              contentFulHeader={contentFulHeader}
            />

            <div className="ml-0 flex h-full w-full justify-center md:justify-start lg:relative lg:ml-20 xl:ml-0 xl:w-fit">
              <HeaderLogo
                logo={logo}
                logoLink={logoLink}
                imageClassName="flex h-32 w-130 md:w-159 md:h-40 lg:w-270 lg:h-67"
              />
            </div>

            <div className="flex">
              <div className="relative hidden w-[450px] px-16 py-12 md:block">
                <div className="search-trigger" onClick={() => setIsAlgoliaSearch(true)}>
                  <SearchInputAlgolia searchConfiguration={searchConfiguration} />
                </div>
              </div>

              <UtilitySection
                emptyCartTitle={emptyCartTitle}
                emptyCartSubtitle={emptyCartSubtitle}
                emptyCartImage={emptyCartImage}
                emptyCartCategories={emptyCartCategories}
                emptyWishlistTitle={emptyWishlistTitle}
                emptyWishlistSubtitle={emptyWishlistSubtitle}
                emptyWishlistImage={emptyWishlistImage}
                emptyWishlistCategories={emptyWishlistCategories}
              />
            </div>
          </div>

          <div className="relative block w-full border-t border-neutral-400 bg-[#f6f6f6] p-12 md:hidden">
            <SearchInputAlgolia searchConfiguration={searchConfiguration} />
          </div>

          {/* <HeaderNavigationDesktop links={navLinks} tiles={tiles ?? []} /> */}
          <HeaderNavigationTopLevel data={menu} />
        </header>
      )}
    </div>
  );
};
export default Header;
